import { imagesKeys } from "../data/modules/_modules";
import { SCREEN_WIDTH } from '../utils/consts';

const getImageSrc = (key) => {
    if (!imagesKeys.hasOwnProperty(key)) {
        return ''
    }
    const isLogo = key.includes('logo');
    const breakpoint = isLogo ? SCREEN_WIDTH.MOBILE_XS : SCREEN_WIDTH.LAPTOP_L;
    return imagesKeys[key][window.innerWidth <= breakpoint ? 'small' : 'large'];
};

export default getImageSrc;
